// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import {
  Box,
  Button,
  Chip,
  Icon,
  Image,
  Typography,
  shadows,
} from "@outschool/backpack";
import { faStar } from "@outschool/icons";
import React from "react";

interface MixTopicCardProps {
  title: string;
  imageUrl: string;
  isDefault: boolean;
  isSelected: boolean;
  onCardClick: () => void;
  onButtonClick: () => void;
}

export default function MixTopicCard({
  title,
  imageUrl,
  isDefault,
  isSelected,
  onCardClick,
  onButtonClick,
}: MixTopicCardProps) {
  return (
    <Box
      role="button"
      tabIndex={0}
      aria-label={`Select topic: ${title}`}
      onClick={onCardClick}
      sx={{
        display: "flex",
        flexDirection: "column",
        width: 224,
        height: 292,
        padding: "0.75em",
        backgroundColor: isDefault ? "primary.50" : "warning.100",
        borderRadius: "1em",
        borderWidth: "2px",
        borderStyle: "solid",
        borderColor: isSelected ? "primary.700" : "transparent",
        cursor: "pointer",
        "&:hover": {
          boxShadow: shadows[50],
        },
        "&:focus-visible": {
          outline: "2px solid",
          outlineColor: "primary.800",
          outlineOffset: "2px",
        },
      }}
    >
      {isDefault ? (
        // same size as the chip to keep alignment
        <Box sx={{ height: "21px" }} />
      ) : (
        <Chip
          label="My Mix"
          size="small"
          color="warning"
          icon={<Icon icon={faStar} />}
          sx={{ alignSelf: "flex-start" }}
        />
      )}
      <Image
        src={imageUrl}
        alt={title}
        sx={{
          width: "100%",
          height: "134px",
          objectFit: "cover",
          borderRadius: "0.5em",
          marginY: "0.75em",
        }}
      />
      <Typography
        variant="subtitle1"
        sx={{
          overflow: "hidden",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          textOverflow: "ellipsis",
        }}
      >
        {title}
      </Typography>
      <Button
        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
          e.stopPropagation();
          onButtonClick();
        }}
        variant="outlined"
        size="small"
        color="inherit"
        fullWidth
        sx={{ marginTop: "auto" }}
      >
        View Details
      </Button>
    </Box>
  );
}
